window.$ = window.jQuery = require("jquery");
window.Popper = require("popper.js").default;

require("bootstrap");

import 'slick-carousel';

// axios setup start
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// axios setup end